import { render, staticRenderFns } from "./SentimentCatIndia.vue?vue&type=template&id=5d5c81e0&scoped=true"
import script from "./SentimentCatIndia.vue?vue&type=script&lang=js"
export * from "./SentimentCatIndia.vue?vue&type=script&lang=js"
import style0 from "./SentimentCatIndia.vue?vue&type=style&index=0&id=5d5c81e0&prod&scoped=true&lang=css"
import style1 from "./SentimentCatIndia.vue?vue&type=style&index=1&id=5d5c81e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c81e0",
  null
  
)

export default component.exports